import request from "@/api";
import { BaseService } from "@/api/services/baseService";
import type { ProductType, ProductTypeVo } from "@zhihaoscm/entity";
import { confirmable } from "@/utils/decorator/confirmable";
import type { ProductTypeForm } from "@/entity/supply/productType";
import type { IProductTypeOptions } from "@/utils/productType";

class ProdTypeService extends BaseService<ProductType, ProductTypeVo, any, ProductTypeForm> {
    @confirmable({
        msgs: ["是否禁用，禁用后该品类不可选用", "是否启用，启用后该品类可以选用"]
    })
    public async updateState<R = any>(id: number | string, state: number | string): Promise<R> {
        return this.service.post(`${this.path}/update/${id}/state/${state}`);
    }
    /**
     * 下拉选框列表数据
     */
    public async selector(
        state?: number,
        type?: number,
        region?: number,
        keyword?: string
    ): Promise<Array<ProductType>> {
        const { data } = await this.service.get(`${this.path}/selector`, {
            params: {
                state,
                type,
                region,
                keyword
            }
        });
        return data;
    }
    /**
     * 下拉选框列表数据 查出商品列表有的品类
     */
    public async selectorInProduct(params: {
        state?: number;
        type?: number;
        region?: number;
        keyword?: string;
        productType?: number;
    }): Promise<Array<ProductType>> {
        const { data } = await this.service.get(`${this.path}/selector-by-product`, {
            params
        });
        return data;
    }
    /**
     * 下拉选框列表数据 带标签
     */
    public async selectorVo(state?: number, keyword?: string): Promise<Array<IProductTypeOptions>> {
        const { data } = await this.service.get(`${this.path}/selectorVo`, {
            params: {
                state,
                keyword
            }
        });
        return data;
    }

    public async pagingSelector(params: { keyword: string; page: number; size: number }): Promise<ProductType[]> {
        const { data } = await this.service.get(`${this.path}/paging-selector`, { params });
        return data.list;
    }

    public async get(id: number | string): Promise<ProductType> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }

    @confirmable("是否删除，删除后该品类将不再展示")
    public async delete(id: number | string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    // 修改权重值
    public async updateWeight(params: { id: string; weight?: number }): Promise<void> {
        await this.service.put(`${this.path}/weight`, params);
    }

    // 品类三级下拉列表
    public async productTypeOptions(params?: { categoryType?: number }): Promise<IProductTypeOptions[]> {
        const { data } = await this.service.get(`${this.path}/options`, { params });
        return data;
    }
}
export const prodTypeService = new ProdTypeService("/dataService/admin/product-type", request.service);

export const productTypeOptions = async (params?: { categoryType?: number }): Promise<IProductTypeOptions[]> => {
    const { data } = await request.service.get(`/admin/product-type/options`, { params });
    return data;
};
